import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, MARKETING } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const PromoCodeList = () => {
	const defaultSort = useMemo(() => [{ id: 'validFrom', desc: true }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'promoCode',
				accessor: 'promoCode',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'promoCodeType',
				accessor: 'promoCodeType',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.PROMO_CODE_TYPE
			},
			{
				Header: 'creditType',
				accessor: 'creditType',
				filterType: FilterType.string
			},
			{
				Header: 'promoterName',
				accessor: 'promoterName',
				filterType: FilterType.string
			},
			{
				Header: 'oneTime',
				accessor: 'oneTime',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS
			},
			{
				Header: 'pageAvailable',
				accessor: 'pageAvailable',
				filterType: FilterType.multiSelection
			},
			{
				Header: 'percentage',
				accessor: 'percentage',
				filterType: FilterType.float,
				renderCell: ListComponents.PERCENTAGE
			},
			{
				Header: 'minCreditPurchase',
				accessor: 'minCreditPurchase',
				filterType: FilterType.float
			},
			{
				Header: 'maxFreeCredit',
				accessor: 'maxFreeCredit',
				filterType: FilterType.float
			},
			{
				Header: 'freeCreditAmount',
				accessor: 'freeCreditAmount',
				filterType: FilterType.float
			},
			{
				Header: 'validFrom',
				accessor: 'validFrom',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'expiry',
				accessor: 'expiry',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'clientID',
				accessor: 'clientID',
				filterType: FilterType.string
			}
		],
		[]
	);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.PROMOTIONS}
				columns={columns}
				fetchUrl={MARKETING.GET_PROMO_CODES_LIST}
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
				exportName="promoCodes"
				defaultSort={defaultSort}
				showMapViewButton
			/>
		</TabTableContainer>
	);
};

export default PromoCodeList;
